import { Component, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { KooperationspartnerEdit } from "../../Controlls/EditViews/KooperationspartnerEdit";
import { PopUpView } from "../../../Componente/PopUpView";
import { KooperationsPartner } from "../../../Api/DcoApi/Admin/AdminClasses2";


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, KooperationspartnerEdit, PopUpView
  ],
  selector: 'KooperationsPartner',
  templateUrl: './KooperationsPartner.html',
  standalone: true,
  styleUrl: './KooperationsPartner.css'
})
export class KooperationsPartnerList {
  @ViewChild('Grid') childComponent!: DataGridView<KooperationsPartner>;

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }
}
